import { BaseShippingZonesClient } from "@core/types";

class ShippingZonesClient extends BaseShippingZonesClient {
  async getShippingZones() {
    return [];
  }

  async getCheckAddressForExpress() {
    return [] as any;
  }
}

export default ShippingZonesClient;
